import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { getTenant } from '../../theme/tokens';
export function LoadingScreen() {
  const {
    t
  } = useTranslation('common');
  const tenant = getTenant();
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-50 flex items-center justify-center" style={{
    backgroundColor: 'var(--colors-background-sidebar)'
  }} data-id="element-15264" data-mp="15f13nkhffo92">
      <div className="text-center space-y-8" data-id="element-15265" data-mp="19dh0sh782d07">
        {/* Logo with pulse animation */}
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.5
      }} className="flex justify-center" data-id="element-15266" data-mp="1o6aga2mhut4v">
          <img src={tenant.brand.logo?.light} alt={tenant.brand.name} className="h-16 w-auto object-contain" data-id="element-15267" data-mp="1t17o5681ewg6" />
        </motion.div>
        {/* Loading text */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="space-y-2" data-id="element-15268" data-mp="cozezpbjz5qw">
          <h2 className="text-xl font-semibold text-white" data-id="element-15269" data-mp="rjnorfnzkqcb">
            {t('ui.LoadingScreen.loading_your_dashboard')}
          </h2>
          <p className="text-sm text-gray-400" data-id="element-15270" data-mp="10ch7xo6k09vg">
            {t('ui.LoadingScreen.please_wait_a_moment')}
          </p>
        </motion.div>
        {/* Shimmer skeleton cards */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="grid grid-cols-3 gap-4 max-w-2xl mx-auto px-8" data-id="element-15271" data-mp="15doghpgitd36">
          {[1, 2, 3].map(i => <div key={i} className="rounded-lg h-24 overflow-hidden relative" style={{
          backgroundColor: 'var(--colors-sidebar-border)'
        }} data-id="element-15272" data-mp="knarpinajcs0">
              <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent" animate={{
            x: ['-100%', '100%']
          }} transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'linear',
            delay: i * 0.2
          }} style={{
            backgroundSize: '200% 100%'
          }} data-id="element-15273" data-mp="ujxewe33afx7" />
            </div>)}
        </motion.div>
        {/* Progress bar */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="max-w-xs mx-auto" data-id="element-15274" data-mp="3f3lazzqcmxbj">
          <div className="h-1 rounded-full overflow-hidden" style={{
          backgroundColor: 'var(--colors-sidebar-border)'
        }} data-id="element-15275" data-mp="1zlf0xc3fmzq1">
            <motion.div className="h-full rounded-full" style={{
            backgroundColor: 'var(--brand-primary)'
          }} initial={{
            width: '0%'
          }} animate={{
            width: '100%'
          }} transition={{
            duration: 2,
            ease: 'easeInOut'
          }} data-id="element-15276" data-mp="1prpumhb34hbp" />
          </div>
        </motion.div>
        {/* Spinning loader */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="flex justify-center" data-id="element-15277" data-mp="2w7s2etoy9q12">
          <div className="w-8 h-8 border-3 border-t-transparent rounded-full animate-spin" style={{
          borderColor: 'var(--brand-primary)',
          borderTopColor: 'transparent'
        }} data-id="element-15278" data-mp="w7dguuchvxqy" />
        </motion.div>
      </div>
    </motion.div>;
}